import cn from 'classnames';

const getDataQa = (id, item) => `${id}${item}Cta`;

export const menuB2BLinkItems = (isAuthenticated, classNames) => [
  {
    id: 'header.menu.account',
    icon: 'account',
    /**
     * This classname helps to open the modal from manomano-sf script
     * to login when the user is on mobile version (Clicking on Account / Compte Icon )
     */
    className: cn(
      isAuthenticated ? undefined : 'js-user-authentication-modal--mobile',
      classNames.mobileAccount,
    ),
    url: 'header.menu.account.url',
    size: '3 3 18 18',
    dataQaSelect: getDataQa('select', 'UserAccount'),
    dataQaIcon: getDataQa('icon', 'UserAccount'),
    dataQaText: getDataQa('text', 'UserAccount'),
  },
  {
    id: 'header.menu.lists',
    icon: 'list',
    className: classNames.mobileList,
    url: 'header.menu.lists.url',
    size: 22,
    dataQaSelect: 'selectUserListsB2b',
  },
  {
    id: 'header.menu.basket',
    icon: 'basket',
    className: classNames.mobileBasket,
    url: 'header.menu.basket.url',
    dataQaSelect: getDataQa('select', 'Basket'),
    dataQaIcon: getDataQa('icon', 'Basket'),
    dataQaText: getDataQa('text', 'Basket'),
  },
];

export const menuLinkItems = (isB2B, isAuthenticated, classNames) => {
  return menuB2BLinkItems(isAuthenticated, classNames).filter(
    item => item.icon !== 'list' || isB2B,
  );
};
